<template>
  <div v-if="about">
    <h3 class="mb-5">Brand Messaging</h3>
    <div class="h4 mb-5">顯示於AboutUS頁面</div>

    <!-- Title -->
    <label class="form-item d-flex py-5">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.title }}
      </div>
    </label>
    <!-- Content -->
    <label class="form-item d-flex py-5">
      <h4 class="w-180px">SubTitle</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.subtitle }}
      </div>
    </label>
    <!-- img uploader -->
    <div class="pa-5 d-flex">
      <div class="w-180px">
        <h4>Banner</h4>
      </div>
      <div class="flex-grow-1 d-flex justify-end">
        <div
          class="w-305px h-187px bg-cover bg-center"
          :style="{
            'background-image': `url(${about.banner})`,
            'border-radius': '6.2px',
            'background-size': 'contain',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
